// Coordinate-grid intent handlers.

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import { applyAxisGrid } from '@scene/grid';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    offs.push(store.onIntent(INTENTS.SET_SHOW_GRID, (p) => {
        if (!p) return;
        const v = !!p.value;
        if (p.plane === 'XY') params.showGridXY = v;
        else if (p.plane === 'XZ') params.showGridXZ = v;
        else if (p.plane === 'YZ') params.showGridYZ = v;
        applyAxisGrid(viewer, params);
    }));

    return offs;
}
